<ng-template #online>
  <a class="text-white text-decoration-none green"
     [routerLink]="isOperator ? ['../chargingstations'] : ['chargingstations']" [queryParams]="{sort: 2}">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-power big-icons">
      <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
      <line x1="12" y1="2" x2="12" y2="12"></line>
    </svg>
    <h3>{{ chargingPointsStatus.online }}</h3>
    <h5 i18n="@@Ready">Bereit</h5>
  </a>
</ng-template>

<ng-template #charging>
  <a class="text-white text-decoration-none orange"
     [routerLink]="isOperator ? ['../chargingstations'] : ['chargingstations']" [queryParams]="{sort: 3}">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-zap big-icons">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
    </svg>
    <h3>{{ chargingPointsStatus.charging }}</h3>
    <h5 i18n="@@Charging">Lädt</h5>
  </a>
</ng-template>

<ng-template #busy>
  <a class="text-white text-decoration-none blue"
     [routerLink]="isOperator ? ['../chargingstations'] : ['chargingstations']" [queryParams]="{sort: 8}">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info big-icons">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
    <h3>{{ chargingPointsStatus.busy }}</h3>
    <h5 i18n="@@Busy">Belegt</h5>
  </a>
</ng-template>

<ng-template #offline>
  <a class="text-white text-decoration-none grey" [routerLink]="isOperator ? ['../chargingstations'] : ['chargingstations']" [queryParams]="{sort: 11}">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         class="feather feather-x-octagon big-icons">
      <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </svg>
    <h3>{{ chargingPointsStatus.offline }}</h3>
    <h5 i18n="@@Offline">Offline</h5>
  </a>
</ng-template>

<ng-template #unregistered>
  <a class="text-white text-decoration-none black" [routerLink]="isOperator ? ['../chargingstations'] : ['chargingstations']" [queryParams]="{sort: 1}">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         class="feather feather-alert-octagon big-icons">
      <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    <h3>{{ chargingPointsStatus.unregistered }}</h3>
    <h5 i18n="@@Unregistered">Unregistriert</h5>
  </a>
</ng-template>

<ng-template #toolTipBusy>
  <div class="text-start text-left">
    An diesen Ladepunkten sind Fahrzeuge angeschlossen, aber es fließt gerade kein Strom.
    <ul style="margin-bottom:5px;">
      <li>Entweder wurde der Ladevorgang noch nicht gestartet oder reserviert,</li>
      <li>das Fahrzeug ist voll geladen,</li>
      <li>lädt aufgrund einer Einstellung im Fahrzeug später,</li>
      <li>oder das Lastmanagement pausiert gerade die Ladung, weil nicht genügend Strom zur Verfügung steht.</li>
    </ul>
    Die Details können Sie an den einzelnen Ladepunkten einsehen.
  </div>
</ng-template>

<div *ngIf="chargingPointsStatus" class="card" [ngStyle]="{'margin-bottom': (isOperator) ? '1em' : '0'}">
  <div class="card-header card-title">
    <h5 class="m-0 p-0" i18n="@@ChargingPoints">Ladepunkte</h5>
  </div>

  <div class="card-body">
    <div class="card-tiles">
      <div class="tile" ngbTooltip="Diese Ladepunkte sind bereit für einen Ladevorgang.">
        <div class="disabled" *ngIf="!chargingPointsStatus?.online">
          <ng-container *ngTemplateOutlet="online"></ng-container>
        </div>
        <div *ngIf="chargingPointsStatus?.online">
          <ng-container *ngTemplateOutlet="online"></ng-container>
        </div>
      </div>

      <div class="tile" ngbTooltip="Diese Ladepunkte laden aktuell.">
        <div class="disabled" *ngIf="!chargingPointsStatus?.charging">
          <ng-container *ngTemplateOutlet="charging"></ng-container>
        </div>
        <div *ngIf="chargingPointsStatus?.charging">
          <ng-container *ngTemplateOutlet="charging"></ng-container>
        </div>
      </div>

      <div class="tile" [ngbTooltip]="toolTipBusy">
        <div class="disabled" *ngIf="!chargingPointsStatus?.busy">
          <ng-container *ngTemplateOutlet="busy"></ng-container>
        </div>
        <div *ngIf="chargingPointsStatus?.busy">
          <ng-container *ngTemplateOutlet="busy"></ng-container>
        </div>
      </div>

      <div class="tile" ngbTooltip="Zu diesen Ladepunkten besteht keine aktive Internetverbindung oder die Stromversorgung für die Ladestationen ist ausgeschaltet.">
        <div class="disabled" *ngIf="!chargingPointsStatus?.offline">
          <ng-container *ngTemplateOutlet="offline"></ng-container>
        </div>
        <div *ngIf="chargingPointsStatus?.offline">
          <ng-container *ngTemplateOutlet="offline"></ng-container>
        </div>
      </div>

    </div>
    <div class="progress-stacked mt-3">
      <div class="progress rounded-start" role="progressbar" aria-label="Segment one" aria-valuenow="{{ chargingPointsStatus.online}} " aria-valuemin="0" aria-valuemax="{{ this.max}}" style="{{ 'width:'+(chargingPointsStatus.online/this.max) * 100+'%' }}">
        <div class="progress-bar green rounded-start" ngbTooltip="{{ chargingPointsStatus.online}} von {{ this.max}}  Ladestation(en) sind bereit für einen Ladevorgang."></div>
      </div>
      <div class="progress rounded-0" role="progressbar" aria-label="Segment two" aria-valuenow="{{ chargingPointsStatus.charging}}" aria-valuemin="0" aria-valuemax="{{ this.max}}" style="{{ 'width:'+(chargingPointsStatus.charging/this.max) * 100+'%' }}">
        <div class="progress-bar orange rounded-0" ngbTooltip="{{ chargingPointsStatus.charging}} von {{ this.max}}  Ladestation(en) laden aktuell."></div>
      </div>
      <div class="progress rounded-0" role="progressbar" aria-label="Segment three" aria-valuenow="{{ chargingPointsStatus.busy}}" aria-valuemin="0" aria-valuemax="{{ this.max}}" style="{{ 'width:'+(chargingPointsStatus.busy/this.max) * 100+'%' }}">
        <div class="progress-bar blue rounded-0" ngbTooltip="{{ chargingPointsStatus.busy }} von {{ this.max}} Ladestation(en) sind belegt."></div>
      </div>
      <div class="progress rounded-0" role="progressbar" aria-label="Segment three" aria-valuenow="{{ chargingPointsStatus.offline}}" aria-valuemin="0" aria-valuemax="{{ this.max}}" style="{{ 'width:'+(chargingPointsStatus.offline/this.max) * 100+'%' }}">
        <div class="progress-bar grey rounded-0" ngbTooltip="{{ chargingPointsStatus.offline}} von {{ this.max}} Ladestation(en) haben keine aktive Internetverbindung oder die Stromversorgung für die Ladestation(en) ist ausgeschaltet."></div>
      </div>

    </div>
  </div>

</div>
